import React from 'react';
import { Switch, FormControlLabel } from '@mui/material';
import { useThemeContext } from '../../styles/ThemeContext'; // Import the context hook

const ThemeToggle = () => {
  const { darkMode, toggleTheme } = useThemeContext(); // Access darkMode and toggleTheme from context

  return (
    <FormControlLabel
      control={
        <Switch
          checked={darkMode}
          onChange={toggleTheme}
          name="themeSwitch"
          color="primary"
        />
      }
    />
  );
};

export default ThemeToggle;
